import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import AsLiquidLimitCuringSection from '../LiquidLimitCuringSection';
import LiquidLimitEquipmentDetailsSection from '../LiquidLimitEquipmentDetailsSection';
import { default as AsLiquidLimitOnePointDeterminationSection } from './LiquidLimitOnePointDeterminationSection';
import LiquidLimitOnePointResultsSection from './LiquidLimitOnePointResultsSection';

let AsLiquidLimitOnePointSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <AsLiquidLimitCuringSection />
        <AsLiquidLimitOnePointDeterminationSection />
      </NamePrefixModifier>
      <LiquidLimitOnePointResultsSection />
    </>
  );
};

AsLiquidLimitOnePointSection = withInjectedProps(AsLiquidLimitOnePointSection);

export { AsLiquidLimitOnePointSection };
export default AsLiquidLimitOnePointSection;
